import { Typography, Box, createTheme, ThemeProvider } from "@mui/material";
import baseTheme from "../../../themes/baseTheme";
const { palette } = baseTheme;
const theme = createTheme({});
const padding = "16px 24px";

export default function TemplateSectionList({
  status,
  headers = [],
  sectionName,
  templateSectionTypeName,
  ...props
}) {


  return (
    <>
      <ThemeProvider theme={theme}>
        <Box
          display="flex"
          padding={padding}
          borderBottom="solid 1px"
          borderColor={palette.grey[30]}
          alignItems="center"
        >
          <Box width={headers.find((h) => h.id === "sectionsName") ?? "66%"}>
            <Typography>{sectionName}</Typography>
          </Box>
          <Box width={headers.find((h) => h.id === "Action")}>
            <Typography>{templateSectionTypeName}</Typography>
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
}
